import { environmentBase } from './config';

export const environment = {
  ...environmentBase,
  apiUrl: '/pq-test',
  dealerTypeId: 1,
  userInactivityMinutes: 15,
  userInactivityResponseSeconds: 30,
  okta: {
    domain: 'autht.securebanklogin.com',
    clientId: '0oa107ogfnqruaO8A1d8',
    redirectUri: 'https://pivotquote.dfsfintest.com/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },
};
